<template>
  <v-layout class="justify-center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <template v-slot:activator="{ on }">
        <div class="cursor-type flex justify-center" v-on="on">
          <slot></slot>
        </div>
      </template>
      <v-card>
        <v-card-title class="headline font-weight-black text-color-title">{{i18n(title)}}</v-card-title>
        <v-card-text>
          <span class="font-weight-medium color-text-literals">{{i18n('Você tem certeza')}}?</span>
          <span class="font-weight-medium color-text-literals">{{i18n('Esta operação não poderá ser desfeita')}}.</span>
        </v-card-text>
        <v-card-actions>
          <v-layout class="row wrap">
            <v-flex class="flex-justify-between">
              <v-btn flat class=" mr-1 adjust-btn-width font-weight-black  mx-auto text-color" @click="cancel">{{i18n('Cancelar')}}</v-btn>
              <v-btn flat class="pa-2 font-weight-black  secondary-bg-color adjust-btn-width mx-auto cancel-btn" dark @click="confirm">{{i18n('Confirmar')}}</v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  export default {
    name: 'DeleteModal',
    props:{
      title: {
        type: String,
        default: "Excluir registro"
      }
    },
    data () {
      return {
        dialog: false,
      }
    },
    methods: {
      i18n(str) {
        return this.$root.l(str)
      },
      confirm(str) {
        this.dialog = false
        this.$emit('onConfirm')
      },
      cancel(str) {
        this.dialog = false
        this.$emit('onCancel')
      }
    }
  }
</script>

<style scoped>
.secondary-bg-color{
  background-color: var(--secondary-button-background-color) !important;
}
.color-text-literals{
  color: rgba(46, 49, 49, 1) !important;
}
.text-color{
  color: var(--background-color) !important;
}
.text-color-title{
  color: #44517B  !important;
}
.cursor-type{
  cursor: pointer;
}
.flex {
  display: flex;
}
.flex-justify-between{
  display: flex;
  justify-items: between;
}
</style>



// WEBPACK FOOTER //
// src/DeleteModal.vue